///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/components/presenters/bool/defaults"/>

export const trueLabel = "#Core/yes";
export const falseLabel = "#Core/no";
export const nullLabel = "#Core/null";
export const template = "presenters-bool-default";